var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"massanumberuploadmembers"},[_c('MassAnumberUploadMember',{attrs:{"aNumbers":_vm.aNumbers,"massANumberUploadMember":_vm.massANumberUploadMember}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }